import React from 'react'
import './task-card-modal-2023.css'
import { taskCardAnimateIn, taskCardAnimateOut, freshSubtask } from '../AdminTasks/adminTaskUtils'
import Subtask2023 from './Subtask2023/Subtask2023'
import TaskCardSettingBar from './TaskCardSettingBar/TaskCardSettingBar'
import axios from 'axios'
import { baseUrl } from '../assets/Animations'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const TaskCardModal2023 = ({setOpenModal2023, openModal2023, setTodos, setShowNotes}) => {
    React.useEffect(() => taskCardAnimateIn('task-card-modal-2023__wrapper', 'task-card-modal-2023'), [])

    const checkForAutoClear = (val) => {
        val === "New Task..." && setOpenModal2023({...openModal2023, todoName: ''})
    }

    const saveAndCloseTask = () => {
        setShowNotes(false)
        taskCardAnimateOut('task-card-modal-2023__wrapper', 'task-card-modal-2023')
        axios.put(`${baseUrl}/tasks/${openModal2023.todoId}`, openModal2023, myHeader)
        .then((res) => {
            setTodos(prev => (prev.map((todo) => todo.todoId === res.data.todoId ? res.data : todo)))
            setOpenModal2023(false)
        })
        .catch((err) => console.log(err))
    }

    return (
        <div className='task-card-modal-2023__wrapper' id='task-card-modal-2023__wrapper' onClick={(e) => e.target.id === 'task-card-modal-2023__wrapper' && saveAndCloseTask()}>
            <div className='task-card-modal-2023' id='task-card-modal-2023'>
                <input className='task-card-modal-2023__task-name' value={openModal2023.todoName} onClick={(e) => checkForAutoClear(e.target.value)} onChange={(e) => setOpenModal2023({...openModal2023, todoName: e.target.value})} />
                <TaskCardSettingBar openModal2023={openModal2023} setOpenModal2023={setOpenModal2023} />
                {openModal2023.todoSubtasks.map((subtask) => <Subtask2023 key={subtask.subtaskId} subtask={subtask} openModal2023={openModal2023} setOpenModal2023={setOpenModal2023} />)}
                <div className='task-card-modal-2023__add-subtask' onClick={() => setOpenModal2023({...openModal2023, todoSubtasks: [...openModal2023.todoSubtasks, freshSubtask()]})}>+ Add Subtask</div>
            </div>
        </div>
    )
}
export default TaskCardModal2023